import { CLIENT_MODULES } from '../constants/clientModules';
import {
  EDUCATION_ONLY_MODULE_KEYS,
  IMMIGRATION_ONLY_MODULE_KEYS,
  REAL_ESTATE_ONLY_MODULE_KEYS,
} from './industryModules';

const MODULE_BY_KEY = Object.fromEntries(CLIENT_MODULES.map((m) => [m.key, m]));

export function moduleLabel(key) {
  return MODULE_BY_KEY[key]?.label || key;
}

export function catalogKeysForIndustry(industryName) {
  const name = (industryName || '').toLowerCase();
  const drop = new Set();
  if (name.includes('immigr')) {
    REAL_ESTATE_ONLY_MODULE_KEYS.forEach((k) => drop.add(k));
    EDUCATION_ONLY_MODULE_KEYS.forEach((k) => drop.add(k));
  } else if (name.includes('educat')) {
    REAL_ESTATE_ONLY_MODULE_KEYS.forEach((k) => drop.add(k));
    IMMIGRATION_ONLY_MODULE_KEYS.forEach((k) => drop.add(k));
  } else {
    IMMIGRATION_ONLY_MODULE_KEYS.forEach((k) => drop.add(k));
    EDUCATION_ONLY_MODULE_KEYS.forEach((k) => drop.add(k));
  }
  return CLIENT_MODULES.map((m) => m.key).filter((k) => !drop.has(k));
}

/** Build display rows for plan-included modules (industry catalog only). */
export function buildPlanFeatureRows(features, industryName) {
  const map = features && typeof features === 'object' ? features : {};
  return catalogKeysForIndustry(industryName).map((key) => ({
    key,
    label: moduleLabel(key),
    enabled: !!map[key],
  }));
}

export function countEnabledFeatures(rows) {
  return rows.filter((r) => r.enabled).length;
}
